import { Helmet } from 'react-helmet'
interface Props {
  seoTitle: string
}

export default function SeoHead({ seoTitle }: Props) {
  return (
    <Helmet>
      <meta charSet="UTF-8" />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>
        {seoTitle} - {process.env.REACT_APP_SITE_NAME || 'Treasures Unlimited'}
      </title>
      <meta name="description" content="abcd" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      {/* <link rel="icon" href={favicon} type="image/x-icon" /> */}
    </Helmet>
  )
}
